import { theme } from '@Guidelines/Theme/theme';
import ArchivedDocumentTypeCardActions from '@UI/Pages/DocumentTemplates/OrganizationDocumentTemplates/Sections/TemplateAssignements/ArchivedDocumentTypeCard/ArchivedDocumentTypeCardActions';
import type DocumentTypeView from '@UI/Store/DocumentTypes/Views/DocumentTypeView';
import { css } from '@emotion/react';
import type * as React from 'react';
import { GridItem } from '@verclam/grid-system';
import { Tag } from '@verclam/ui-kit';

const cardStyle = css`
	padding: 1.25rem;
	border-radius: ${theme.radii.xlarge};
	background-color: ${theme.colors.surfaceMuted};
	border: 1.5px solid ${theme.colors.border};
`;

const typeNameStyle = css`
	margin: 0;
	font-family: ${theme.fonts.body};
	font-size: ${theme.fontSizes.large};
	font-weight: ${theme.fontWeights.semibold};
	color: ${theme.colors.inkMuted};
`;

type Props = {
	readonly documentType: DocumentTypeView;
};

/**
 * One archived document type, grayed out in the very same grid as the active assignment cards —
 * the user's own decision against a separate "archived" section. Poses as `TemplateAssignmentCard`'s
 * own shape (`GridItem subgrid='rows'`, same `columnSize`, four tracks) so both card kinds settle
 * block for block on a shared grid row; only ever mounted alongside `DOCUMENT_TYPE_WRITE`.
 */
const ArchivedDocumentTypeCard: React.FC<Props> = ({ documentType }) => {
	return (
		<GridItem subgrid={'rows'} columnSize={{ xl: 1, lg: 2, md: 2 }} css={cardStyle}>
			<h3 css={typeNameStyle}>{documentType.label}</h3>

			<Tag value="Archivé" severity="secondary" />

			<ArchivedDocumentTypeCardActions documentTypeId={documentType.id} />

			<div />
		</GridItem>
	);
};

export default ArchivedDocumentTypeCard;
